import { useContext, createContext } from "react";

const WebsocketContext = createContext(null);
export const useWebsocketStore = () => useContext(WebsocketContext);

export const WebSocketProvider = ({ store, children }) => {
  return (
    <WebsocketContext.Provider value={store}>
      {children}
    </WebsocketContext.Provider>
  );
};
